export default "__VITE_ASSET__C4AsC97E__"